import * as Sentry from '@sentry/browser';
import loadConfiguration from 'ggApp/utils/configuration';
import { ErrorLink } from '@apollo/client/link/error';

const { SENTRY_ENV } = loadConfiguration();
const untrackedErrorStatuses = new Set([400, 401, 404]);
const untrackedGraphqlErrors = new Set(['UNAUTHENTICATED']);
const reportingEnvironments = new Set(['staging', 'qa', 'production']);

const ErrorMiddleware = new ErrorLink(({ graphQLErrors, networkError, operation }) => {
    const { getContext } = operation;
    const { cookiesManager } = getContext();
    const userId = cookiesManager?.get('user_id');

    if (networkError && !untrackedErrorStatuses.has(networkError?.status)) {
        if (reportingEnvironments.has(SENTRY_ENV)) {
            Sentry.configureScope((scope) => {
                scope.setUser({ id: userId });
                Sentry.captureException(networkError);
            });
        } else {
            console.error(`[Network error]: ${networkError}`);
        }
    }

    if (graphQLErrors) {
        graphQLErrors
            .filter((error) => !untrackedGraphqlErrors.has(error.extensions?.code))
            .forEach((gqlError) => {
                const { message, locations, path } = gqlError;

                if (reportingEnvironments.has(SENTRY_ENV)) {
                    Sentry.configureScope((scope) => {
                        scope.setUser({ id: userId });
                        scope.setExtra('locations', locations);
                        scope.setExtra('path', path);
                        Sentry.captureException(message);
                    });
                } else {
                    console.error(
                        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
                    );
                }
            });
    }
});

export default ErrorMiddleware;
